import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-contactPhone-lookup',
  templateUrl: './micro-contactPhone-lookup.component.html'
})
export class MicroContactPhoneLookupComponent  {

  @Input()
  contactId:any;

  @Input()
  span:false;
}
